import { Box, Button, CardMedia, CircularProgress } from '@mui/material'
import DialogComponent from 'components/DialogComponent'
import React from 'react'
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ImageViewModal = ({ open, handleClose, file, handleDownload, isLoading }) => {
    return (
        <DialogComponent
            title="View Site Image"
            open={open}
            handleClose={handleClose}
            maxWidth='md'
        >
            <CardMedia
                component="img"
                sx={{ height: "500px", width: "100%", objectFit: "cover" }}
                image={file?.filePath || ""}
                alt={"image"}
            />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1.5,
                    //mt: 3,
                    pt: 2,
                    borderTop: "1px solid #F3F4F6",
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#00344C",
                        borderRadius: "25px",
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "100%",
                        fontFamily: "Outfit, sans-serif",
                        color: "#FFFFFF",
                        px: "20px",
                        py: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    }}
                    onClick={() => handleDownload(file)}
                >
                    {isLoading ? <CircularProgress color='white' size={"15px"} /> : <FileDownloadIcon />} Download
                </Button>
            </Box>
        </DialogComponent>
    )
}

export default ImageViewModal
